export default __webpack_public_path__ + "static/media/manual16.e3d17d1d.png";